module.exports = __webpack_public_path__ + "static/img/CC3.b02f7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CC3.png
// module id = JSiQ
// module chunks = 0